<template>
  <div class="mt-4 mb-4 pa-5" style="width: 100%">
    <Loading v-if="!isLoad" />
    <div v-show="results">
      <!-- ビデオ再生ダイアログ -->
      <v-dialog v-model="open" width="600px">
        <VideoDialog :dialog="Dialog" />
      </v-dialog>
      <!-- チャンネル詳細ダイアログ -->
      <v-dialog v-model="detailOpen" width="50%">
        <v-card>
          <v-card-title class="headline">{{ channel.title }}</v-card-title>
          <v-card-text>
            <v-layout row justify-center pa-3>
              <v-flex xs12 sm12 md12>
                <v-label>基本情報</v-label>
                <v-img
                  class="white--text align-end mb-3"
                  width="100%"
                  height="300px"
                  v-bind:src="channel.thumbnail"
                >
                </v-img>
                <div>チャンネル登録者数：{{ channel.subscriber_count }} 人</div>
                <div>総再生数：{{ channel.view_count }} 回</div>
                <div>動画投稿数：{{ channel.video_count }} 個</div>
                <div>最終更新日：{{ channel.updated_at }}</div>
                <div>詳細：</div>
                <div>{{ channel.description | truncate }}</div>
                <br />
                <v-label>最新の投稿一覧</v-label>
                <v-list three-line>
                  <template v-for="item in channel.videos">
                    <v-list-item :key="item.title" @click="openDialog(item)">
                      <v-list-item-avatar>
                        <v-img :src="item.thumbnail"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="item.title"
                        ></v-list-item-title>
                        <v-list-item-subtitle>{{
                          item.published_at | dispDate
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- 一覧表示 -->
      <template width="100%">
        <v-data-table
          v-if="isList"
          :headers="headers"
          :items="dtItems"
          :items-per-page="30"
        >
          <!-- チャンネルタイトル列用のテンプレート -->
          <template v-slot:item.title="{ item }">
            <v-layout>
              <div class="mr-3">
                <v-img
                  v-on:load="load"
                  width="30px"
                  height="30px"
                  :src="item.thumbnail"
                >
                </v-img>
              </div>
              {{ item.title | truncate }}
            </v-layout>
          </template>
          <!-- ビデオ再生列用のテンプレート -->
          <template v-slot:item.id="{ item }">
            <v-icon @click="openDetail(item)">event_note</v-icon>
          </template>
        </v-data-table>
      </template>
      <!-- コレクション表示 -->
      <v-layout row wrap v-if="!isList">
        <v-flex
          xs6
          sm3
          md2
          lg2
          v-for="channel in results"
          v-bind:key="channel.id"
        >
          <v-card class="ma-2" @click.stop="openDetail(channel)">
            <v-img
              v-on:load="load"
              class="white--text align-end"
              width="100%"
              height="100%"
              v-bind:src="channel.thumbnail"
            >
              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
            <v-card-text class="text--primary">
              <div>{{ channel.title | truncate }}</div>
              <v-layout>
                <v-icon>how_to_reg</v-icon>
                ： {{ channel.subscriber_count }} 人
              </v-layout>
              <v-layout>
                <v-icon>visibility</v-icon>
                ： {{ channel.view_count }} 回
              </v-layout>
              <v-layout>
                <v-icon>videocam</v-icon>
                ： {{ channel.video_count }} 個
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import ApiService from "../common/api.service";
import VideoDialog from "../components/Dialog";
import Loading from "../components/Loading";
import Mixin from "../mixin";

const MAX_DETAIL_LENGTH = 100;
const MAX_SEARCH_RESULTS = 50;

export default {
  name: "Channel",
  components: {
    VideoDialog,
    Loading,
  },
  data() {
    return {
      detailOpen: false,
      Dialog: {
        VideoID: "",
        Title: "",
      },
      results: null,
      channel: [],
      headers: [
        { text: "チャンネル", value: "title" },
        { text: "登録者数", value: "subscriber_count" },
        { text: "総再生数", value: "view_count" },
        { text: "ビデオ数", value: "video_count" },
        { text: "詳細", value: "id", align: "center", sortable: false },
      ],
      dtItems: [],
      isLoad: false,
    };
  },
  mixins: [Mixin],

  async mounted() {
    await this.getChannels();
  },
  filters: {
    truncate: function (value) {
      if (value == undefined) {
        return "";
      }
      if (value.length <= MAX_DETAIL_LENGTH) {
        return value;
      }
      return value.substr(0, MAX_DETAIL_LENGTH) + "...";
    },
  },
  methods: {
    getChannels: function () {
      ApiService.get("channel/list").then((res) => {
        this.results = res.data.result;
        // DataTable表示用に配列オブジェクトに変換して保持
        this.convertTableData(this.results);
      });
    },
    searchChannels: function (keyword) {
      const params = {
        keyword: keyword,
      };
      ApiService.get("channel/search", params).then((res) => {
        // Card表示用のデータ
        this.results = res.data.result;
        // DataTable表示用に配列オブジェクトに変換して保持
        this.convertTableData(this.results);
      });
    },
    convertTableData: function (value) {
      value.forEach((value) => {
        const item = {
          title: value.title,
          subscriber_count: value.subscriber_count,
          view_count: value.view_count,
          video_count: value.video_count,
          id: value.id,
          thumbnail: value.thumbnail,
          description: value.description,
          videos: value.videos,
        };
        this.dtItems.push(item);
      });
    },
    // チャンネル詳細ダイアログを開く
    openDetail: function (channel) {
      console.log(channel);
      this.channel = channel;
      this.detailOpen = true;
    },
  },
  created() {
    this.$store.watch(
      (state) => state.keyword,
      (keyword) => {
        this.searchChannels(keyword);
        this.convertTableData(this.results);
      }
    );
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
